import * as React from 'react'
import { FilterItem } from '../filters'
import { WikiItem } from 'types/wiki'

function useFilters<Type extends WikiItem>(items: Type[], defaultActiveFilters?: FilterItem[]) {
    const [activeFilters, setActiveFilters] = React.useState<FilterItem[]>([])
    const [activeTags, setActiveTags] = React.useState<string[]>([])
    const [search, setSearch] = React.useState<string>('')

    React.useEffect(() => {
        if (defaultActiveFilters) {
            setActiveFilters(defaultActiveFilters)
            setActiveTags(defaultActiveFilters.flatMap((filter) => filter.tags))
        }
    }, [defaultActiveFilters])

    const clearFilters = () => {
        setActiveFilters([])
        setActiveTags([])
    }

    const addFilter = (item: FilterItem) => {
        setActiveFilters((activeFilters) => [...activeFilters, item])
        setActiveTags((activeTags) => [...activeTags, ...item.tags])
    }

    const removeFilter = (slug: string) => {
        const index = activeFilters.findIndex((i) => i.slug === slug)
        const newChecked = [...activeFilters]
        if (index > -1) newChecked.splice(index, 1)
        setActiveFilters(newChecked)

        const newActiveTags = activeTags.filter((tag) => newChecked.some((filter) => filter.tags.includes(tag)))
        setActiveTags(newActiveTags)
    }

    const filteredItems = React.useMemo(() => {
        return items.filter((item) => {
            const filtersMatch = activeTags.length ? activeTags.includes(item.slug) : true
            const searchMatch = !!search ? item.title.toLocaleLowerCase().includes(search.toLowerCase().trim()) : true
            return filtersMatch && searchMatch
        })
    }, [activeTags, search, items])

    return {
        addFilter,
        removeFilter,
        clearFilters,
        activeFilters,
        search,
        setSearch,
        filteredItems,
    }
}

export default useFilters
